<template>
	<BoxList v-loading="loading">
		<template v-slot:form>
			<el-form
				size="small"
				:inline="true"
				label-position="right"
				label-width="140px"
			>
				<el-col :span="8">
					<el-form-item label="手机IMEI码">
						<el-input v-model.trim="form.imei" placeholder="请输入" clearable></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="受理类型">
						<el-select v-model="form.insuredContent" filterable clearable>
							<el-option
								v-for="item in acceptTypeList"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="产品名称">
						<el-input v-model.trim="form.productName" placeholder="请输入" clearable></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="保单状态">
						<el-select v-model="form.policyStatus" filterable clearable>
							<el-option
								v-for="item in policyStatusList"
								:key="item.value"
								:label="item.label"
								:value="item.label"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="理赔类型">
						<el-select v-model="form.woAcceptType" filterable clearable>
							<el-option
								v-for="item in claimStatusList"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="理赔状态">
						<el-select v-model="form.woRepairStatus" filterable clearable>
							<el-option
								v-for="item in woRepairStatusList"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="渠道">
						<el-input v-model.trim="form.channelName" placeholder="请输入" clearable></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label=" ">
						<el-button type="primary" @click="seanch">查询</el-button>
					</el-form-item>
				</el-col>
			</el-form>
		</template>
		<template v-slot:show>
			<el-table
				:data="list"
				size="small"
				row-key="pkClaimId"
				border
				fit
				stripe
				:max-height="tableHeight"
				style="width: 100%"
			>
				<el-table-column
					width="150px"
					prop="woRepairNo"
					label="理赔工单号"
					align="center"
				>
					<template slot-scope="scope">
						<span>{{ scope.row.woRepairNo }}</span>
					</template>
				</el-table-column>
				<el-table-column
					width="120px"
					prop="imei"
					label="IMEI码"
					align="center"
				>
				</el-table-column>
				<el-table-column
					width="120px"
					prop="woRepairStatusDesc"
					label="理赔状态"
					align="center"
				>
				</el-table-column>
				<el-table-column
					width="140px"
					prop="productName"
					label="产品名称"
					align="center"
				>
				</el-table-column>
				<el-table-column
					width="140px"
					prop="channelName"
					label="渠道"
					align="center"
				>
				</el-table-column>
				<el-table-column
					width="110px"
					prop="userName"
					label="客户姓名"
					align="center"
				>
				</el-table-column>
				<el-table-column
					width="120px"
					prop="phoneNo"
					label="联系电话"
					align="center"
				>
				</el-table-column>
				<el-table-column
					width="120px"
					prop="woAcceptTypeDesc"
					label="理赔类型"
					align="center"
				>
				</el-table-column>
				<el-table-column
					width="120px"
					prop="salePrice"
					label="产品售价"
					align="center"
				>
					<template slot-scope="scope">
						<span>{{ scope.row.salePrice }}</span>
					</template>
				</el-table-column>
				<el-table-column
					width="160px"
					prop="insuredContent"
					label="保障内容"
					align="center"
				>
				</el-table-column>
				<el-table-column
					width="120px"
					prop="policyStatusDesc"
					label="保单状态"
					align="center"
				>
				</el-table-column>
				<el-table-column
					fixed="right"
					width="110px"
					label="操作"
					align="center"
				>
					<template slot-scope="scope">
						<el-button @click="rowView(scope.row)" type="text" size="small">
							查看详情
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<Page
				:pageNo="page.no"
				:pageSize="page.size"
				:pageCount="page.count"
				@pageChange="pageChange"
			></Page>
		</template>
	</BoxList>
</template>

<script>
import BoxList from "@/components/use/box/BoxList";
export default {
	name: "claimList",
	components: {
		BoxList,
	},
	data() {
		return {
			loading: false,
			// 1:换新/盗抢；2:维修/碎屏 3换修二合一，5渤海保障产品
			acceptTypeList: [
				// { value: 1, label: "换新/盗抢" },
				{ value: 2, label: "维修/碎屏" },
				{ value: 3, label: "换修二合一" },
				// { value: 5, label: "渤海保障产品" },
			],
			productNameList: [
				{ value: 1, label: "手机保险" },
				{ value: 2, label: "数码保险" },
				{ value: 3, label: "家电保险" },
				{ value: 4, label: "车辆保险" },
			],
			/*
			* 保单状态
			* 
			* 	0  问题保单
				1  待提交
				2  投保
				3  投保
				4  在保
				5  在保
				6  在保
				7  在保
				8  保单过期
				9  保单中止
				10  渠道退保
				11  待支付
				12  退款成功
				13  待上传
				14  待完善
				15  未承保
			*/
			// 生产汉字匹配，状态无所谓
			policyStatusList: [
				// { value: 0, label: "问题保单" },
				{ value: 1, label: "待提交" },
				// { value: 2, label: "投保" },
				{ value: 7, label: "在保" },
				{ value: 8, label: "保单过期" },
				{ value: 9, label: "保单中止" },
				{ value: 10, label: "渠道退保" },
				// { value: 11, label: "待支付" },
				// { value: 12, label: "退款成功" },
				// { value: 13, label: "待上传" },
				// { value: 14, label: "待完善" },
				// { value: 15, label: "未承保" }
			],
			auditStatusList: [
				{ value: 1, label: "待审核" },
				{ value: 2, label: "审核通过" },
				{ value: 3, label: "审核拒绝" },
				{ value: 4, label: "审核中" },
			],
			// 理赔类型：1换新，2维修，3投诉
			claimStatusList: [
				{ value: 1, label: "换新" },
				{ value: 2, label: "维修" },
				// { value: 3, label: "投诉" },
			],
			// 待定
			// rep_apply("rep_apply","服务已受理待收理赔资料"),
			// rep_prepare_verify("rep_prepare_verify","资料待审核"),
			// rep_replenish_data("rep_replenish_data","需补充资料"),
			// rep_refuse("rep_refuse","拒绝理赔"),
			// rep_accept("rep_accept","审核通过，接受理赔(待报价)"),
			// rep_cancle("rep_cancle","客户取消理赔"),
			// rep_confirm_quote("rep_confirm_quote","确认报价"),
			// rep_again_quote("rep_again_quote","重新报价"),
			// rep_replenish_pay("rep_replenish_pay","待付款"),
			// rep_self_payed("rep_self_payed","已收自付款"),
			// rep_prepare_repair("rep_prepare_repair","待维修"),
			// rep_done("rep_done","已维修待邮寄"),
			// rep_examine_success("rep_examine_success","维修审核成功"),
			// rep_send("rep_send","维修已发货"),
			// rep_refuse_send("rep_refuse_send","拒绝已回寄"),
			// rep_self_taken("rep_self_taken","客户自取"),
			// order_break("order_break","工单中止"),
			// rep_total_loss("rep_total_loss","全损工单"),
			// return_order("return_order","核赔退回"),
			// order_accept("order_accept","审核通过"),
			// order_change("order_change","已修改"),
			// order_refuse("order_refuse","审核驳回"),
			// return_tl_order("return_tl_order","全损核赔退回")
			woRepairStatusList: [
				{
					value: 'rep_apply',
					label: "服务已受理待收理赔资料",
				},
				// {
				// 	value: 'rep_prepare_verify',
				// 	label: "资料待审核",
				// },
				// {
				// 	value: 'rep_replenish_data',
				// 	label: "需补充资料",
				// },
				{
					value: 'rep_refuse',
					label: "拒绝理赔",
				},
				{
					value: 'rep_accept',
					label: "审核通过，接受理赔(待报价)",
				},
				{
					value: 'rep_cancle',
					label: "客户取消理赔",
				},
				// {
				// 	value: 'rep_confirm_quote',
				// 	label: "确认报价",
				// },
				// {
				// 	value: 'rep_again_quote',
				// 	label: "重新报价",
				// },
				// {
				// 	value: 'rep_replenish_pay',
				// 	label: "待付款",
				// },
				// {
				// 	value: 'rep_self_payed',
				// 	label: "已收自付款",
				// },
				{
					value: 'rep_prepare_repair',
					label: "待维修",
				},
				{
					value: 'rep_done',
					label: "已维修待邮寄",
				},
				// {
				// 	value: 'rep_examine_success',
				// 	label: "维修审核成功",
				// },
				// {
				// 	value: 'rep_send',
				// 	label: "维修已发货",
				// },
				// {
				// 	value: 'rep_refuse_send',
				// 	label: "拒绝已回寄",
				// },
				// {
				// 	value: 'rep_self_taken',
				// 	label: "客户自取",
				// },
				{
					value: 'order_break',
					label: "工单中止",
				},
				// {
				// 	value: 'rep_total_loss',
				// 	label: "全损工单",
				// },
				// {
				// 	value: 'return_order',
				// 	label: "核赔退回",
				// },
				{
					value: 'order_accept',
					label: "审核通过",
				},
				// {
				// 	value: 'order_change',
				// 	label: "已修改",
				// },
				{
					value: 'order_refuse',
					label: "审核驳回",
				},
				// {
				// 	value: 'return_tl_order',
				// 	label: "全损核赔退回",
				// },
			],
			form: {
				imei: "",
				// 受理类型
				insuredContent: "",
				productName: "",
				policyStatus: "",
				// 理赔状态
				woAcceptType: "",
			},
			formInit: { ...this.form },
			seanchData: {},
			list: [],
			page: {
				count: 0,
				no: 1,
				size: 10,
			},
		};
	},
	mounted() {
		this.seanch();
	},
	methods: {
		pageChange(obj) {
			this.page.no = obj.no;
			this.page.size = obj.size;
			this.getList();
		},
		seanch() {
			this.seanchData = { ...this.form };
			this.page.no = 1;
			this.getList();
		},
		getList() {
			const vm = this;
			vm.loading = true;
			let postData = { ...this.seanchData };
			postData.pageNum = this.page.no;
			postData.pageSize = this.page.size;
			vm.list = [];
			this.$http
				.post(`/workOrder/queryWorkOrderListByPage`, postData)
				.then(function (response) {
					console.log('res-page', response);
					vm.loading = false;
					if (response.status == "200" && response.data) {
						vm.list =  response.data.dataList ? response.data.dataList : [];
						vm.page.count = response.data.total;
					} else {
						vm.$message.error('查询失败请重试！');
					}
				})
				.catch(function (error) {
					vm.loading = false;
				});
		},
		rowView(obj) {
			this.$router.push({
				path: "/claimManagement/claimDetail",
				query: {
					id: obj.id,
				}
			})
		},
		getAcceptTypeLabel(value) {
			const item = this.acceptTypeList.find((item) => item.value === value);
			return item ? item.label : "";
		},
		getProductNameLabel(value) {
			const item = this.productNameList.find((item) => item.value === value);
			return item ? item.label : "";
		},
		getPolicyStatusLabel(value) {
			const item = this.policyStatusList.find((item) => item.value === value);
			return item ? item.label : "";
		},
		getAuditStatusLabel(value) {
			const item = this.auditStatusList.find((item) => item.value === value);
			return item ? item.label : "";
		},
		getClaimStatusLabel(value) {
			const item = this.claimStatusList.find((item) => item.value === value);
			return item ? item.label : "";
		},
	},
	computed: {
		tableHeight() {
			let height = this.$store.state.tableHeight;
			if (this.$store.state.view == "wap") {
				return 10000;
			} else {
				return height;
			}
		},
	},
	watch: {
		"$store.state.tabs.refresh": function () {
			if (this.$route.path == this.$store.state.tabs.refresh) {
				this.getList();
			}
		},
	},
};
</script>

<style lang="scss" scoped type="text/css"></style>